import React from 'react';
import './index.css';
import clsx from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';

const Footer = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const items = [
    {
      name: '首页',
      path: '/',
    },
    {
      name: '业务方案',
      path: '/business',
    },
    {
      name: '资质证书',
      path: '/certificate',
    },
    {
      name: '报告查询',
      path: '/check',
    },
  ];

  const onPath = (path) => {
    history.push(path);
    // 如果当前path和点击的path一致，则缓慢滚动到顶部
    if (pathname === path) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  const onClick = () => {
    window.open('https://beian.miit.gov.cn/');
  };

  return (
    <div className={clsx('footer')}>
      <div className={clsx('footer-content')}>
        <div className={clsx('footer-content-left')}>
          <img src='/images/footerLogo.png' alt='' width={148} height={120} />
          <div className={clsx('footer-content-left-items')}>
            {items.map((item) => (
              <div
                className={clsx('footer-content-left-items_item')}
                key={item.name}
                onClick={() => onPath(item.path)}
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
        <div className={clsx('footer-content-right')}>
          <div className={clsx('footer-content-right-info')}>
            <div className={clsx('footer-content-right-info-contact')}>
              <img
                src='/images/phoneIcon.png'
                alt='icon'
                width={16}
                height={16}
              />
              <span>联系电话：</span>
            </div>
            <div className={clsx('footer-content-right-info-phone-big')}>
              135-8819-5927（汪经理） /&emsp;0571-89185205
            </div>
            <div className={clsx('footer-content-right-info-phone-small')}>
              135-8819-5927（汪经理）
              <br /> 0571-89185205
            </div>
            <div className={clsx('footer-content-right-info-contact')}>
              <img
                src='/images/emailIcon.png'
                alt='icon'
                width={16}
                height={16}
              />
              <span>电子邮箱：</span>
            </div>
            <div className={clsx('footer-content-right-info-phone')}>
              zjsj202601@126.com
            </div>
            <div className={clsx('footer-content-right-info-contact')}>
              <img
                src='/images/addressIcon.png'
                alt='icon'
                width={16}
                height={16}
              />
              <span>地址：</span>
            </div>
            <div className={clsx('footer-content-right-info-phone')}>
              浙江省杭州市余杭区瓶窑镇崇化村嵩山头51号
            </div>
          </div>
          <div className={clsx('footer-qrcode')}>
            <img src='/images/qrcode.png' alt='' width={184} height={184} />
            <div className={clsx('footer-qrcode-text')}>汪经理</div>
          </div>
        </div>
      </div>
      <div className={clsx('footer-copyright')}>
        Copyright © 2026 浙江上检电力检测有限公司All Rights Reserved
        <div onClick={onClick}>浙ICP备19052375号-2</div>
      </div>
    </div>
  );
};

export default Footer;
